export const setCookie = (name, value) => {
  let expires = new Date(Date.now() + 365 * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
};

export const getCookie = (name) => {
  return document.cookie.split('; ').reduce((r, v) => {
    let parts = v.split('=');
    return parts[0] === name ? decodeURIComponent(parts[1]) : r;
  }, '');
};

export const generateVisitorId = () => {
  //---NOTE: create UUID like 'e45f14e0-3b62-4c57-bd7c-6e3e93a9e04d'
  let visitorId = 'xxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    let r = (Math.random() * 16) | 0;
    let v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
  setCookie('visitorUUID', visitorId);
  return visitorId;
};
